import styled from 'styled-components'

export const MapContainer = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba( 250, 250, 250, 0.9);
    z-index: 100;
    cursor: pointer;
`

export const Content = styled.div`
    position: relative;
`

export const MapInner = styled.div`
    width: 30rem;
    height: 30rem;
    overflow: hidden;
    border-radius: 5px;
    position: relative;

    @media all and (max-width: 450px) {
        width: 20rem;
    }
`

export const IconContainer = styled.div`
    width: 3rem;
    height: 3rem;
    position: relative;
`

export const Icon = styled.img`
    width: 100%;
    height: auto;
    object-fit: contain;
    position: absolute;
    top: -2.5rem;
    left: -1.4rem;
`

export const X = styled.p`
    position: absolute;
    top: -2rem;
    right: -2rem;
    border-radius: 500px;
    width: 2rem;
    height: 2rem;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1.5rem;
    color: #ffffff;
    background-color: var(--main-black);
    pointer-events: none;
    line-height: 1;

    @media all and (max-width: 450px) {
        top: -3rem;
        right: 0;
    }
`